import { useRouter } from 'next/router';
import { DEFAULT_APP_LOCALE } from '@/lib/constants';

/** Resolves API `language` when Next.js i18n routing is disabled (`router.locale` may be undefined). */
export function useAppLocale(): string {
  const { locale } = useRouter();
  return locale ?? DEFAULT_APP_LOCALE;
}
